import { createContext } from "react";

export interface ReadOnlyModeContextValue {
  isReadOnly: boolean;
}

export const ReadOnlyModeContext = createContext<ReadOnlyModeContextValue>({
  isReadOnly: false,
});
